import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';

export interface HeroMetaItem {
  icon: string;
  text: string;
}

@Component({
  selector: 'htx-hero-section',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroSectionComponent {
  title = input.required<string>();
  subtitle = input<string>('');
  metaItems = input<HeroMetaItem[]>([]);
  flatBottom = input<boolean>(false);
}
